
export function DisplayCurrency(x) {
  return Number.parseFloat(x).toFixed(2);
}


/**
 * Performs a case insensitive comparison
 * 
 * @param {string} str1 
 * @param {string} str2 
 */
export function stringCompare(str1, str2) {
  if (str1.toUpperCase() === str2.toUpperCase())
    return true;

  return false;
}



/*

function quickSort(arr, leftPos, rightPos, arrLength) {
  let initialLeftPos = leftPos;
  let initialRightPos = rightPos;
  let direction = true;
  let pivot = rightPos;
  while ((leftPos - rightPos) < 0) {
    if (direction) {
      if ( sortTrans( arr[pivot], arr[leftPos] ) === -1 ) { // if (arr[pivot] < arr[leftPos]) {
        quickSort.swap(arr, pivot, leftPos);
        pivot = leftPos;
        rightPos--;
        direction = !direction;
      } else
        leftPos++;
    } else {
      if ( sortTrans( arr[pivot], arr[leftPos] ) < 1 ) {
        rightPos--;
      } else {
        quickSort.swap(arr, pivot, rightPos);
        leftPos++;
        pivot = rightPos;
        direction = !direction;
      }
    }
  }
  if (pivot - 1 > initialLeftPos) {
    quickSort(arr, initialLeftPos, pivot - 1, arrLength);
  }
  if (pivot + 1 < initialRightPos) {
    quickSort(arr, pivot + 1, initialRightPos, arrLength);
  }
}
quickSort.swap = (arr, el1, el2) => {
  let swapedElem = arr[el1];
  arr[el1] = arr[el2];
  arr[el2] = swapedElem;
}

*/



